
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDUGDKKR_LjE8ozmyrdbUCD8N1I_mcaSm8",
  authDomain: "ccb-banco.firebaseapp.com",
  projectId: "ccb-banco",
  storageBucket: "ccb-banco.firebasestorage.app",
  messagingSenderId: "362497999153",
  appId: "1:362497999153:web:8c1e1d88c92f339443f010",
  measurementId: "G-7P842SNQL7"
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { auth, db, storage };